import { useRoutes } from 'react-router-dom';

import { BreadcrumbedRouteObject, useRegisterPaths } from './utils';

export const useRoutesWithBreadcrumbs = (
  routes: BreadcrumbedRouteObject[],
): ReturnType<typeof useRoutes> => {
  useRegisterPaths(routes, '');
  return useRoutes(routes);
};
